// extracted by mini-css-extract-plugin
module.exports = {"add-new-menu":"add-new-menu_add-new-menu__1V_aJ"};